import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import api from '../../lib/api';
import { Button } from '../ui/button';

const Side = ({ title, doc, testid, onPick, picked, pickLabel }) => (
  <div data-testid={testid} className={`rounded-xl border p-3 flex flex-col gap-2 ${picked ? 'border-blue-500 ring-2 ring-blue-200' : 'border-slate-200'}`}>
    <div className="flex items-center justify-between">
      <span className="font-bold text-slate-900 text-sm">{title}</span>
      <Button size="sm" data-testid={`${testid}-pick`} onClick={onPick} className={picked ? 'bg-blue-600 text-white' : ''} variant={picked ? 'default' : 'outline'}>{pickLabel}</Button>
    </div>
    <pre dir="ltr" className="text-[11px] leading-5 bg-slate-50 rounded-lg p-2 max-h-80 overflow-auto whitespace-pre-wrap break-all text-slate-700 text-left">
      {doc ? JSON.stringify(doc, null, 2) : '— غير موجود —'}
    </pre>
  </div>
);

export const ConflictCompare = ({ item, onDecide }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/publish/item', { params: { collection: item.collection, id: item.id } }).then(r => setData(r.data));
  }, [item.collection, item.id]);
  if (!data) return <Loader2 className="w-5 h-5 animate-spin text-blue-600" />;
  return (
    <div className="grid md:grid-cols-2 gap-3" data-testid="publish-conflict-compare">
      <Side title="نسخة المعاينة" testid="compare-preview" doc={data.preview} picked={item.decision === 'preview'}
        pickLabel={data.preview ? 'اعتماد هذه' : 'اعتماد الحذف'} onPick={() => onDecide(item.key, 'preview')} />
      <Side title="نسخة الموقع الحي" testid="compare-live" doc={data.live} picked={item.decision === 'live'}
        pickLabel="الإبقاء عليها" onPick={() => onDecide(item.key, 'live')} />
    </div>
  );
};
